import { Injectable, ErrorHandler, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { IErrorResponse } from '@interfaces';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { EMPTY } from '@utils';

@Injectable()
export class ExceptionService implements ErrorHandler {
  private responseBody: IErrorResponse;

  constructor(
    private router: Router,
  ) {
    this.responseBody = {title: '', message: ''};
  }

  errorHandling(err: HttpErrorResponse): IErrorResponse {
    const { error, message, name, ok, status, statusText, url } = err;
    let fails = [''];
    if (typeof error !== 'undefined') {
      fails = Object.keys(error);
    }

    if (!environment.production) {
      console.log(err);
    } else {
      console.log('\n-----------------------');
      console.log(`status: ${status}`);
      console.log(`statusText: ${statusText}`);
      console.log(`url: ${url}`);
      console.log(`name: ${name}`);
      console.log(`message, ${message}`);
      console.log(`detail: ${error['detail']}`);
      console.log('-----------------------\n');
    }

    if (status === 400) {
      if (error === EMPTY) {
        this.responseBody.title = '';
        this.responseBody.message = '';
      } else {
        if (error.hasOwnProperty('message')) {
          this.responseBody.title = fails[0];
          this.responseBody.message = error['message'];
        } else {
          this.responseBody.title = fails[0];
          this.responseBody.message = error[fails[0]][0];
        }
      }
    } else if (status === 0) {
      const currentUrl = this.router.url;
      const tempUrl = localStorage.getItem('temp_url');

      if (currentUrl !== '/connectionerror') {
        localStorage.setItem('temp_url', this.router.url);
      }

      this.responseBody.title = 'error';
      this.responseBody.message = 'No se pudo establecer conexión con el servidor';
      this.router.navigate(['/connectionerror']);
    } else if (status === 401) {
      if (error.hasOwnProperty('detail')) {
        localStorage.removeItem('token');
        localStorage.removeItem('temp_url');
        if (error['detail'].toLowerCase() === 'signature has expired.') {
          //
        } else if (error['detail'].toLowerCase() === 'authentication credentials were not provided.') {
          //
        }
        this.router.navigate(['/']);
      } else {
        this.responseBody.title = 'error';
        this.responseBody.message = statusText;
        this.router.navigate(['/']);
      }
    } else if (status === 500) {
      this.responseBody.title = (!environment.production) ? name : 'Atencion';
      this.responseBody.message = (!environment.production) ? statusText : 'No se pudo procesar la solicitud';
    }

    return this.responseBody;
  }

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
       // Server or connection error happened
       if (!navigator.onLine) {
         // Handle offline error
       } else {
         // Handle Http Error (error.status === 403, 404...)
       }
    } else {
      // Handle Client Error (Angular Error, ReferenceError...)
    }
  }
}
